import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, IconButton, Card, CardContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './questionBankModal.less';
import { getQuestionBankData } from '../../../../api/chatAPI';

const QuestionBankModal = ({ open, onClose, onQuestionSelect }) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchQuestions = async () => {
        setLoading(true);
        try {
            const res = await getQuestionBankData();
            console.log(res, 'res');
            if (!res) {
                if (res.status === 204) {
                    throw new Error('No questions found');
                } else if (res.status === 401) {
                    throw new Error('Invalid token');
                } else {
                    throw new Error('Failed to fetch questions');
                }
            }

            const data = res;
            console.log('QuestionBankModal: API res:', data);

            // Sort categories by name in ascending order
            const sortedCategories = [...data].sort((a, b) => a.Category.localeCompare(b.Category));
            setCategories(sortedCategories);
        } catch (err) {
            console.error('QuestionBankModal: Error fetching questions:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    // Fetch questions from API
    useEffect(() => {
        if (!open) return; // Only fetch when modal is open
        fetchQuestions();
    }, [open]);

    const handleQuestionClick = (question) => {
        console.log('QuestionBankModal: Selected question:', question.Question);
        onQuestionSelect(question.Question);
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="question-bank-modal-title"
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    maxWidth: '90%',
                    maxHeight: '90%',
                    width: 1000,
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                }}
            >
                {/* Header with Title and Close Icon */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2,
                        borderBottom: '1px solid #e0e0e0',
                        position: 'sticky',
                        top: 0,
                        bgcolor: 'background.paper',
                        zIndex: 1,
                    }}
                >
                    <Typography id="question-bank-modal-title" variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                        Question Bank
                    </Typography>
                    <IconButton onClick={onClose} sx={{ color: '#666' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Scrollable Content */}
                <Box
                    sx={{
                        flex: 1,
                        overflowY: 'auto',
                        p: 3,
                        bgcolor: '#f5f5f5',
                    }}
                    className="question-bank-content"
                >
                    {loading && <Typography sx={{ textAlign: 'center', p: 2 }}>Loading questions...</Typography>}
                    {error && <Typography sx={{ textAlign: 'center', p: 2, color: 'red' }}>Error: {error}</Typography>}
                    {!loading && !error && categories.length === 0 && (
                        <Typography sx={{ textAlign: 'center', p: 2 }}>No questions available</Typography>
                    )}
                    {!loading &&
                        !error &&
                        categories.map((category) => (
                            <Box key={category.Category} sx={{ mb: 4 }}>
                                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'medium', color: '#333' }}>
                                    {category.Category}
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(4, 1fr)',
                                        gap: 2,
                                    }}
                                >
                                    {category.Questions.map((q) => (
                                        <Card
                                            key={q.QuestionID}
                                            className="question-card"
                                            sx={{
                                                bgcolor: 'white',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.03)',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                },
                                            }}
                                            onClick={() => handleQuestionClick(q)}
                                        >
                                            <CardContent sx={{ p: 2 }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontSize: '0.9rem',
                                                        color: '#333',
                                                        lineHeight: 1.4,
                                                        minHeight: '4rem',
                                                    }}
                                                >
                                                    {q.Question}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    ))}
                                </Box>
                            </Box>
                        ))}
                </Box>
            </Box>
        </Modal>
    );
};

export default QuestionBankModal;
// import React from 'react';
// import {
//     Modal,
//     Box,
//     Typography,
//     IconButton,
//     Card,
//     CardContent
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import './questionBankModal.less';

// // Sample list of 55 questions for the question bank
// const questionBank = [
//     "What are the current sales figures for this quarter?",
//     "How does our revenue compare to last year?",
//     "What are the top-performing products in our portfolio?",
//     "Can you analyze customer churn rates for the past six months?",
//     "What are the key trends in our industry right now?",
//     "How effective is our latest marketing campaign?",
//     "What is the employee turnover rate in our organization?",
//     "Can you provide a breakdown of operational costs?",
//     "What are the customer satisfaction scores for our services?",
//     "How does our pricing strategy compare to competitors?",
//     "What is the forecast for next quarter's revenue?",
//     "Can you identify any bottlenecks in our supply chain?",
//     "What are the most common customer complaints?",
//     "How is our brand performing on social media?",
//     "What are the growth opportunities in our market?",
//     "Can you provide a SWOT analysis for our company?",
//     "What is the ROI on our recent investments?",
//     "How does our website traffic compare to last month?",
//     "What are the key drivers of customer loyalty?",
//     "Can you analyze the performance of our sales team?",
//     "What are the current market share figures?",
//     "How effective is our customer support team?",
//     "What are the risks associated with our current strategy?",
//     "Can you provide insights into employee productivity?",
//     "What is the impact of recent regulatory changes?",
//     "How are our competitors performing financially?",
//     "What are the top customer demographics for our products?",
//     "Can you analyze our inventory turnover rates?",
//     "What is the performance of our loyalty program?",
//     "How does our customer acquisition cost compare to industry standards?",
//     "What are the key metrics for our e-commerce platform?",
//     "Can you provide a cash flow analysis?",
//     "What is the adoption rate of our new product line?",
//     "How effective is our employee training program?",
//     "What are the current trends in customer preferences?",
//     "Can you analyze our advertising spend efficiency?",
//     "What is the performance of our regional branches?",
//     "How does our product quality compare to competitors?",
//     "What are the key factors affecting our profitability?",
//     "Can you provide a competitive landscape analysis?",
//     "What is the customer lifetime value for our business?",
//     "How are our subscription services performing?",
//     "What are the barriers to entry in our industry?",
//     "Can you analyze our vendor performance?",
//     "What is the impact of seasonality on our sales?",
//     "How effective is our customer feedback system?",
//     "What are the key performance indicators for our team?",
//     "Can you provide insights into our pricing elasticity?",
//     "What is the market demand for our new product?",
//     "How does our employee satisfaction compare to industry benchmarks?",
//     "What are the opportunities for cost reduction?",
//     "Can you analyze the effectiveness of our CRM system?",
//     "What is the performance of our affiliate marketing program?",
//     "How are our sustainability initiatives impacting our brand?",
//     "What are the key challenges in our current market?"
// ];

// const QuestionBankModal = ({ open, onClose, onQuestionSelect }) => {
//     const handleQuestionClick = (question) => {
//         console.log('QuestionBankModal: Selected question:', question);
//         onQuestionSelect(question);
//         onClose();
//     };

//     return (
//         <Modal
//             open={open}
//             onClose={onClose}
//             aria-labelledby="question-bank-modal-title"
//             sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//         >
//             <Box
//                 sx={{
//                     bgcolor: 'background.paper',
//                     borderRadius: 2,
//                     boxShadow: 24,
//                     maxWidth: '90%',
//                     maxHeight: '90%',
//                     width: 1000,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     position: 'relative'
//                 }}
//             >
//                 {/* Header with Title and Close Icon */}
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         p: 2,
//                         borderBottom: '1px solid #e0e0e0',
//                         position: 'sticky',
//                         top: 0,
//                         bgcolor: 'background.paper',
//                         zIndex: 1
//                     }}
//                 >
//                     <Typography
//                         id="question-bank-modal-title"
//                         variant="h5"
//                         component="h2"
//                         sx={{ fontWeight: 'bold' }}
//                     >
//                         Question Bank
//                     </Typography>
//                     <IconButton onClick={onClose} sx={{ color: '#666' }}>
//                         <CloseIcon />
//                     </IconButton>
//                 </Box>

//                 {/* Scrollable Content */}
//                 <Box
//                     sx={{
//                         flex: 1,
//                         overflowY: 'auto',
//                         p: 3,
//                         bgcolor: '#f5f5f5'
//                     }}
//                     className="question-bank-content"
//                 >
//                     <Box
//                         sx={{
//                             display: 'grid',
//                             gridTemplateColumns: 'repeat(4, 1fr)',
//                             gap: 2
//                         }}
//                     >
//                         {questionBank.map((q, index) => (
//                             <Card
//                                 key={index}
//                                 className="question-card"
//                                 sx={{
//                                     bgcolor: 'white',
//                                     borderRadius: 2,
//                                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.3s ease',
//                                     '&:hover': {
//                                         transform: 'scale(1.03)',
//                                         boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
//                                     }
//                                 }}
//                                 onClick={() => handleQuestionClick(q)}
//                             >
//                                 <CardContent sx={{ p: 2 }}>
//                                     <Typography
//                                         variant="body2"
//                                         sx={{
//                                             fontSize: '0.9rem',
//                                             color: '#333',
//                                             lineHeight: 1.4,
//                                             minHeight: '4rem'
//                                         }}
//                                     >
//                                         {q}
//                                     </Typography>
//                                 </CardContent>
//                             </Card>
//                         ))}
//                     </Box>
//                 </Box>
//             </Box>
//         </Modal>
//     );
// };

// export default QuestionBankModal;
